import { formatEUR, parseAmountToCents } from '@budget/shared';
import { useState } from 'react';

interface Props {
  label: string;
  valueCents: number;
  onChange: (cents: number) => void;
  hint?: string;
}

/**
 * Champ de montant en saisie libre, pour les formulaires posés (comptes,
 * charges fixes) — le pavé numérique reste réservé à la saisie éclair.
 * La conversion en centimes passe par le même analyseur que le reste.
 */
export function AmountField({ label, valueCents, onChange, hint }: Props) {
  const [text, setText] = useState(valueCents === 0 ? '' : String(valueCents / 100));
  const parsed = parseAmountToCents(text);
  const invalid = text !== '' && parsed === null;

  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-sm text-ink-secondary">{label}</span>
      <input
        type="text"
        inputMode="decimal"
        value={text}
        placeholder="0,00"
        onChange={(event) => {
          setText(event.target.value);
          const cents = parseAmountToCents(event.target.value);
          onChange(cents ?? 0);
        }}
        className={`rounded-xl border bg-surface px-4 py-3 text-base outline-none ${
          invalid ? 'border-critical' : 'border-line focus:border-series'
        }`}
      />
      <span className="text-xs text-ink-muted">
        {invalid ? 'Montant illisible' : (hint ?? formatEUR(parsed ?? 0))}
      </span>
    </label>
  );
}
